module.exports = "../images/eir-cart-icon.svg";